module.exports = __webpack_public_path__ + "img/function_content01.64b36ef8.png";